import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=189a4f3e&scoped=true"
import script from "./UploadFiles.vue?vue&type=script&lang=ts"
export * from "./UploadFiles.vue?vue&type=script&lang=ts"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=189a4f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a4f3e",
  null
  
)

export default component.exports